'use client'

import Script from 'next/script'
import type { ComponentProps } from 'react'
import { useEhTrackingAllowed } from 'hooks/useEhTrackingAllowed/useEhTrackingAllowed'

type ConsentGatedScriptProps = ComponentProps<typeof Script>

/**
 * Renders next/script only after EH consent gate opens (pilot flag on + valid eh_consent_v1).
 */
export function ConsentGatedScript(props: ConsentGatedScriptProps) {
  const trackingAllowed = useEhTrackingAllowed()
  if (!trackingAllowed) return null
  return <Script {...props} />
}
